import api from "./core";

export default {
  getMenus() {
    return api.post(`api/{{serverSegment}}/Menus`, {});
  },
  getClient($id) {
    return api.get(`api/{{serverSegment}}/Patients/${$id}`);
  },
  getLevelsOfCare() {
    return api.post(`api/{{serverSegment}}/LevelOfCare`, {});
  },
  getUtilizationStatuses() {
    return api.post(`api/{{serverSegment}}/UrStatus`, {});
  },
  getLocations() {
    return api.post(`api/{{serverSegment}}/Locations`, {});
  },
  getGenders() {
    return api.post(`api/{{serverSegment}}/Gender`, {});
  },
  getMaritalStatuses() {
    return api.post(`api/{{serverSegment}}/MaritalStatus`, {});
  },
  getStates() {
    return api.post(`api/{{serverSegment}}/State`, {});
  },
  getAllergyTypes() {
    return api.post(`api/{{serverSegment}}/AllergyType`, {});
  },
  getAllergySeverities() {
    return api.post(`api/{{serverSegment}}/AllergySeverity`, {});
  },
  getRelationships() {
    return api.post(`api/{{serverSegment}}/Relationships`, {});
  },
  getCaseRoles() {
    return api.post(`api/{{serverSegment}}/CaseRoles`, {});
  },
  getDiagnosisCodeStatuses() {
    return api.post(`api/{{serverSegment}}/DiagnosisCodeStatus`, {});
  },
  getNutritionCategories() {
    return api.post(`api/{{serverSegment}}/NutritionCategory`, {});
  },
  getNutritionMeals() {
    return api.post(`api/{{serverSegment}}/NutritionMeal`, {});
  },
  getAllergens() {
    return api.post(`api/{{serverSegment}}/Allergen`, {});
  },
  getReactions() {
    return api.post(`api/{{serverSegment}}/Reaction`, {});
  },
  getReviewTypes() {
    return api.post(`api/{{serverSegment}}/UrReviewType`, {});
  },
  getInsuranceCoverages() {
    return api.post(`api/{{serverSegment}}/InsuranceCoverage`, {});
  },
  getMedicationRoutes() {
    return api.post(`api/{{serverSegment}}/MedicationRoute`, {});
  },
  getMeasurements() {
    return api.post(`api/{{serverSegment}}/UnitOfMeasurement`, {});
  },
  getSexes() {
    return api.post(`api/{{serverSegment}}/Sexes`, {});
  },
  getTaxonomySpecialties() {
    return api.post(`api/{{serverSegment}}/TaxonomySpecialty`, {});
  },
  getTaxonomyTypes() {
    return api.post(`api/{{serverSegment}}/TaxonomyType`, {});
  },
  getEntityTypes() {
    return api.post(`api/{{serverSegment}}/EntityType`, {});
  },
  getPayerTypes() {
    return api.post(`api/{{serverSegment}}/PayerTypes`, {});
  },
  getScheduleEventTypes() {
    return api.post(`api/{{serverSegment}}/ScheduleEventType`, {});
  },
  getScheduleEventStatuses() {
    return api.post(`api/{{serverSegment}}/ScheduleEventStatus`, {});
  },
  getRaces() {
    return api.post(`api/{{serverSegment}}/Race`, {});
  },
  getEthnicities() {
    return api.post(`api/{{serverSegment}}/Ethnicity`, {});
  },
  getLanguages() {
    return api.post(`api/{{serverSegment}}/Language`, {});
  },
  getPredefinedProtocols() {
    return api.post(`api/{{serverSegment}}/PredefinedProtocol`, {
      page: 0,
      pageSize: 1000000
    });
  }
};
